import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useCompletedReturnOrderList = ({
  branchFilter,
  myBranchesFilter,
  search,
  page,
  pageSize,
}) => {
  const filter = {
    filter: { noFilter: null, branchFilter: null, searchTerm: search },
    paging: { pageIndex: page },
  };

  if (branchFilter === "Mine") {
    filter.filter.branchFilter = "Mine";
  } else if (branchFilter === "All" && myBranchesFilter === "All") {
    filter.filter.branchFilter = "All";
  } else {
    filter.filter.branchFilter = myBranchesFilter;
  }

  return useQuery({
    queryKey: ["completedReturnOrderList", filter],
    queryFn: async () =>
      callApi({
        path: "completedreturnorderlist",
        command: "",
        data: JSON.stringify({ list: filter }),
      }),
    placeholderData: keepPreviousData,
    staleTime: 5000,
  });
};
